var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "General/Information") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General/Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0484643,7.62811739 C8.89911608,7.85415827 9.26455544,3.35880042 12.0204062,3.27382006 C14.578824,3.1950326 15.1981547,7.40207651 12.0484643,7.62811739",
    id: "Path",
    fill: "#7F97AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2873998,14.9263597 C11.7236482,10.65775 9.7407064,11.9572399 9.04752115,11.6652728 C6.93026239,10.7741005 16.0885553,6.58220944 13.8460126,14.8860007 C12.3606717,20.3846535 14.2799898,18.2561662 15.1982148,18.8753691 C16.1796708,19.5374763 7.08421629,24.4460139 10.2873998,14.9263597",
    id: "Path",
    fill: "#7F97AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.854713,0 C5.30737497,0 0,5.30758342 0,11.8548473 C0,18.4021112 5.30737497,23.7096946 11.854713,23.7096946 C18.4020511,23.7096946 23.7096946,18.4021112 23.7096946,11.8548473 C23.7096946,5.30758342 18.4020511,0 11.854713,0",
    id: "Path",
    stroke: "#7F97AB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.aec4a7dfafa583bbf77960af6749e3ab.svg";
export { ForwardRef as ReactComponent };